
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import {
  calculateDegree,
  useMouseEvents
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";

@Component
export default class GradientControls extends Vue {
  @Prop()
  type!: string;

  @Prop()
  degree!: number;

  @Prop({ default: () => {} })
  changeGradientControl!: Function;

  disableClick = false;

  mouseEvents: (event: MouseEvent) => void = () => {};

  get degreesStyle() {
    return { transform: `rotate(${this.degree}deg)` };
  }

  mounted() {
    this.mouseEvents = useMouseEvents(
      this.mouseDownHandler,
      this.mouseMoveHandler,
      this.mouseUpHandler
    );
  }

  mouseDownHandler(event: MouseEvent) {
    const pointer = event.target as HTMLElement;
    const pointerBox = pointer.getBoundingClientRect();
    const centerY = pointerBox.top + Math.floor(8 - window.pageYOffset);
    const centerX = pointerBox.left + Math.floor(8 - window.pageXOffset);

    return {
      centerY,
      centerX
    };
  }

  mouseMoveHandler(
    event: MouseEvent,
    { centerX, centerY }: { centerX: number; centerY: number }
  ) {
    event.preventDefault();
    this.disableClick = true;

    const newDegree = calculateDegree(
      event.clientX,
      event.clientY,
      centerX,
      centerY
    );
    this.changeGradientControl({ degree: Math.floor(newDegree) });
  }

  mouseUpHandler(event: MouseEvent) {
    event.preventDefault();
    const targetClasses = (event.target as HTMLElement).classList;

    if (
      targetClasses.contains("gradient-degrees") ||
      targetClasses.contains("icon-rotate")
    ) {
      return;
    }

    this.disableClick = false;
  }

  onClickGradientDegree() {
    if (this.disableClick) {
      this.disableClick = false;
      return;
    }

    let gradientDegree = this.degree + 45;

    if (gradientDegree >= 360) {
      gradientDegree = 0;
    }

    this.changeGradientControl({ degree: gradientDegree });
  }

  onInputChange(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    const num = target.value ? target.valueAsNumber : null;

    this.changeGradientControl({ degree: num });
  }
}
